import en from "./En";
import ar from "./Ar";

const messages = {
  en,
  ar,
};

export default messages;
